import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {Title} from "../../entity/model/title";
import {RequestBody} from "../../entity/core/request-body";
import {ReviewStatus} from "../../entity/enums/review-status";

export default class TitleAgent {

    getTitles = async (organizationId: string, projectId: string): Promise<Title[]> => {
        const filter = JSON.stringify({ projectID: projectId });
        return await API.get(awsApiName, `/organizations/${organizationId}/project-titles?filter=${encodeURIComponent(filter)}`, {});
    }

    getTitleById = async (organizationId: string, titleId: string): Promise<Title> => {
        return API.get(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}`, {});
    }

    addNewSection = async (organizationId: string, titleId: string, requestBody: RequestBody): Promise<Title> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/sections`, requestBody);
    }

    addComment = async (organizationId: string, titleId: string, requestBody: RequestBody): Promise<Title> => {
        return API.post(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/comments`, requestBody);
    }

    submitTitle = (organizationId: string, titleId: string): Promise<Title> => {
        return API.post(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/move-to-review`, {});
    }

    reviewTitle = (organizationId: string, titleId: string, reviewStatus: ReviewStatus): Promise<Title> => {
        return reviewStatus === ReviewStatus.REQUEST_CHANGES
            ? API.post(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/move-to-open`, {})
            : API.post(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/move-to-approve`, {});
    }

    approveTitle = (organizationId: string, titleId: string, reviewStatus: ReviewStatus): Promise<Title> => {
        return reviewStatus === ReviewStatus.REQUEST_CHANGES
            ? API.post(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/move-to-review`, {})
            : API.post(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/move-to-completed`, {});
    }
}
